pageNotFoundController.$inject = ['ng1NgXUrlHandlingStrategy', '$location'];

export default function pageNotFoundController(
  ng1NgXUrlHandlingStrategy,
  $location
) {
  const controller = this;
  const url = $location.url();

  controller.shouldDisplay = !ng1NgXUrlHandlingStrategy.shouldProcessUrl(url);
}
